// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import Table from "../ErrorTab/Table";
// import Filtering from "../RuleCatalogue/Filtering";
// import heartLoading from "../../assests/heartLoading.gif";

// const SavedErrorDetails = ({
//   dashboardId = null,
//   currentFilters = {},
//   onFiltersChange,
//   searchTerm = "",
//   onSearchChange,
// }) => {
//   const BASE_URL = process.env.REACT_APP_API_URL;
//   const [page, setPage] = useState(1);
//   const [pageSize] = useState(10);
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(false);

//   // 👉 GET /error-details-view/{dashboard_id}?page=1&pageSize=10
//   useEffect(() => {
//     if (!dashboardId) return;

//     setLoading(true);

//     axios
//       .get(`${BASE_URL}/error-details-view/${dashboardId}?page=${page}&pageSize=${pageSize}`)
//       .then((res) => {
//         setData(res.data);

//         // Sync filters/searchTerm back up
//         if (res.data.filters) onFiltersChange(res.data.filters);
//         if (res.data.search_term) onSearchChange(res.data.search_term);

//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Error fetching saved error details:", err);
//         setLoading(false);
//       });
//   }, [dashboardId, page, pageSize, BASE_URL, onFiltersChange, onSearchChange]);

//   if (!data || loading) {
//     return (
//       <div className="fixed inset-0 bg-white flex items-center justify-center z-50 w-full h-full">
//         <div className="flex flex-col items-center space-y-3">
//           <img src={heartLoading} alt="Loading..." className="h-30" />
//           <span className="text-gray-700 text-[20px]">Hang tight! The resources are loading...</span>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="error-detailss">
//       <Filtering
//         availableFilters={data.filters}
//         currentFilters={currentFilters}
//         onFiltersChange={onFiltersChange}
//         searchTerm={searchTerm}
//         onSearchChange={onSearchChange}
//         disabled={true} 
//       />

//       <Table
//         tableData={data.tableData}
//         pagination={data.pagination}
//         onPageChange={setPage}
//         errorPreviews={data.errorPreviews}
//       />
//     </div>
//   );
// };

// export default SavedErrorDetails;
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Table from "../ErrorTab/Table";
import Filtering from "../RuleCatalogue/Filtering";
import heartLoading from "../../assests/heartLoading.gif";
import preloader from "../../assests/preloader1.gif";

const SavedErrorDetails = ({
  dashboardId = null,
  currentFilters = {},
  onFiltersChange,
  searchTerm = "",
  onSearchChange,
}) => {
  const BASE_URL = process.env.REACT_APP_API_URL;
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const initialLoaded = useRef(false);

  // 👉 GET /error-details-view/{dashboard_id}?page=1&pageSize=10
  useEffect(() => {
    if (!dashboardId) return;

    setLoading(true);

    axios
      .get(
        `${BASE_URL}/error-details-view/${dashboardId}?page=${page}&pageSize=${pageSize}`
      )
      .then((res) => {
        setData(res.data);

        // Only sync filters/searchTerm on first load (avoid loops)
        if (!initialLoaded.current) {
          if (res.data.filters) onFiltersChange(res.data.filters);
          if (res.data.search_term) onSearchChange(res.data.search_term);
          initialLoaded.current = true;
        }

        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching saved error details:", err);
        setLoading(false);
      });
  }, [dashboardId, page, pageSize, BASE_URL]); // ⛔ removed function props

  if (!data || loading) {
    return (
      <div className="fixed inset-0 bg-white flex items-center justify-center z-50 w-full h-full">
        <div className="flex flex-col items-center space-y-3">
          <img src={preloader} alt="Loading..." width={200} />
          <span className="text-gray-700 text-[20px]">
            Hang tight! The resources are loading...
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="error-detailss">
      <Filtering
        availableFilters={data.filters}
        currentFilters={currentFilters}
        onFiltersChange={onFiltersChange}
        searchTerm={searchTerm}
        onSearchChange={onSearchChange}
        disabled={true}
      />

      <Table
        tableData={data.tableData}
        pagination={data.pagination}
        onPageChange={setPage}
        errorPreviews={data.errorPreviews}
      />
    </div>
  );
};

export default SavedErrorDetails;
